/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DateList = {
    type: 'array',
    contains: {
        type: 'string',
        format: 'date',
    },
} as const;
